import React from "react";
import SearchBar from "./components/SearchBar";

const App = () => {
  return (
    <div>
      <SearchBar></SearchBar>
    </div>
  );
};

export default App;
